/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : TRENDING NOW V2 CONFIGURATION GENERAL SECTION - HEADER TITLE : STYLES --------------- ++++++++++ */
export default theme => ({
  headertitle: {
    '& .headericons .icon': {
      height: '70px',
      width: '70px',
      border: '2px solid #CCD1E6',
      borderRadius: '12px',
      padding: '18px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.2s',
      '&:hover': {
        border: '2px solid #97A1CA'
      },
      '&.selected-true': {
        border: '2px solid #3257EC'
      },
      '&.none': {
        background: '#F7F8FC'
      },
      '& img': {
        height: '24px',
        width: 'auto'
      }
    },
    '& .previewconfig': {
      '& .content': {
        fontWeight: 600,
        minHeight: '100px',
        '& .count': {
          background: '#F7F8FC',
          borderRadius: '24px',
          padding: '4px 8px',
          width: '44px',
          height: 'min-content',
          flex: 'none',
          fontSize: '16px',
          margin: '8px'
        },
        '& > div': {
          width: '100%',
          borderBottom: props => props.useHeaderBorder ? '3px solid #000' : 'none',
          paddingBottom: '8px',
          gap: '12px',
          overflowWrap: 'anywhere',
          '& svg': {
            flex: 'none'
          },
          '& h3': {
            fontSize: '24px',
            fontFamily: '"Source Serif Pro", Georgia, serif',
          },
          '& img': {
            height: '24px',
            width: 'auto'
          }
        }
      }
    }
  }
});
